import { render, staticRenderFns } from "./repertoryPrincipalListComponent.vue?vue&type=template&id=1c5be855&scoped=true&"
import script from "./repertoryPrincipalListComponent.vue?vue&type=script&lang=js&"
export * from "./repertoryPrincipalListComponent.vue?vue&type=script&lang=js&"
import style0 from "./repertoryPrincipalListComponent.vue?vue&type=style&index=0&id=1c5be855&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5be855",
  null
  
)

export default component.exports